import React from 'react';

import TourTitle from './title';
import TimeAndDistanceFullView from './TimeAndDistanceFullView';
import GpxUpload from './gpxUpload';
import CreatedBy from './CreatedBy';
import TourTypeFullView from './tourTypeFullView';
import GetAccessDropDown from '../CreateTour/AccesibilityType/getAccessDropDown';

const TourFullHeader = (props) => {
  const { currentTourId, edit, editChoose, hasUserPermition, currentUserId } =
    props;

  return (
    <div className="mainTitle">
      <div className="title">
        <TourTitle />
      </div>
      <div className="infoTourFullTitle">
        <div className="wrapper-distance-upload">
          <span className="distance">
            <TimeAndDistanceFullView />
          </span>
          {edit ? <GpxUpload /> : <CreatedBy />}
        </div>
        <div className="tour-title-devider" />
        <div className="wrapper-access-road-types">
          <div className="tourTypeIcon">
            <TourTypeFullView isCreate={currentTourId} />
          </div>
          <GetAccessDropDown
            editChoose={editChoose}
            hasUserPermition={hasUserPermition}
            edit={edit}
            currentUserId={currentUserId}
          />
        </div>
      </div>
    </div>
  );
};

export default TourFullHeader;
